import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import StudentLoginForm from './components/StudentLoginForm';

const StudentLogin = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
      {/* Header */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <button
              onClick={() => navigate('/splash-page')}
              className="flex items-center space-x-3 hover-lift transition-organic"
            >
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-500 rounded-xl flex items-center justify-center shadow-lg">
                <Icon name="BookOpen" size={24} className="text-white" />
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                LearningTrails
              </span>
            </button>
            <button
              onClick={() => navigate('/teacher-login')}
              className="text-sm text-muted-foreground hover:text-foreground transition-organic flex items-center space-x-2"
            >
              <Icon name="User" size={16} />
              <span>Teacher Login</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="pt-24 pb-12 min-h-screen flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          {/* Welcome Card */}
          <div className="text-center mb-8 stagger-fade-in">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full shadow-lg mb-4">
              <Icon name="Sparkles" size={40} className="text-white" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2">
              Welcome, Student! 🎓
            </h1>
            <p className="text-base text-muted-foreground">
              Sign in to start your learning adventure
            </p>
          </div>

          {/* Login Form Card */}
          <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 stagger-fade-in stagger-delay-1">
            <StudentLoginForm />
          </div>

          {/* Help Section */}
          <div className="mt-6 text-center stagger-fade-in stagger-delay-2">
            <div className="inline-flex items-center space-x-2 text-sm text-muted-foreground bg-white/60 backdrop-blur-sm px-4 py-2 rounded-full">
              <Icon name="HelpCircle" size={16} className="text-blue-500" />
              <span>Need help?</span>
              <button className="text-blue-600 hover:text-blue-700 font-medium transition-organic">
                Ask your teacher
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Background Elements */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
        <div className="absolute top-20 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-purple-200 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute top-1/2 left-1/3 w-36 h-36 bg-pink-200 rounded-full opacity-20 blur-3xl"></div>
      </div>

      {/* Footer */}
      <footer className="fixed bottom-0 left-0 right-0 bg-white/60 backdrop-blur-sm border-t border-border py-4 z-10">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date()?.getFullYear()} LearningTrails. Made with ❤️ for students
          </p>
        </div>
      </footer>
    </div>
  );
};

export default StudentLogin;